"use strict";

define('evisions/redactor.plugins/disabled.redactor.plugin',[], function () {
  if (typeof window.RedactorPlugins === 'undefined') window.RedactorPlugins = {};
  window.RedactorPlugins.disabled = {
    init: function init() {
      var that = this;
      this.disableEditor = function () {
        return that._disableEditor.apply(that, arguments);
      };
      this.enableEditor = function () {
        return that._enableEditor.apply(that, arguments);
      };
      if (this.opts.disabled) {
        this._disableEditor();
      }
    },
    _pasteIntercept: function _pasteIntercept(html) {
      return;
    },
    getEditableDiv: function getEditableDiv() {
      return this.$box.find('.redactor_editor');
    },
    _disableEditor: function _disableEditor() {
      this.getEditableDiv().attr('contenteditable', false);
      this.$toolbar.css('opacity', '.2');
      this.opts.disabled = true;
      this.opts.cleanup = false;
      if (this.opts.toolbar || !this.__toolbarBlocker) {
        this.__toolbarBlocker = $(document.createElement("div")).css({
          'position': 'absolute',
          'top': 0,
          'left': 0,
          'right': 0,
          'height': this.$toolbar.height() || 32,
          'z-index': 10,
          'background-color': 'rgba(0,0,0,0)'
        });
        this.$toolbar.parent().append(this.__toolbarBlocker);
      }
    },
    _enableEditor: function _enableEditor() {
      this.getEditableDiv().attr('contenteditable', true);
      this.$toolbar.css('opacity', '');
      this.opts.disabled = false;
      this.opts.cleanup = true;
      if (this.opts.toolbar && this.__toolbarBlocker) {
        this.__toolbarBlocker.remove();
        this.__toolbarBlocker = null;
      }
    }
  };
  return RedactorPlugins;
});

